import { tw } from '@/utils/tw';

export default tw.theme({
  slots: {
    base: ['w-full', 'aspect-video', 'object-cover'],
    group: ['relative'],
    icon: ['absolute', 'bottom-grid-gap', 'left-grid-gap', 'w-9', 'h-9', 'text-primary-600'],
  },
});
